import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    title: 'Automation',
    description: 'See how we helped a leading insurance brokerage firm automate their statement processing, achieving a 90% reduction in manual effort and near real-time data integration with Microsoft Dynamics CRM (e.g., reducing manual processing time by up to 70%).',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80',
    link: '/solutions/automation'
  },
  {
    title: 'AI & Analytics',
    description: 'Leverage sophisticated AI models to predict trends, customer behavior, and market dynamics. Our predictive analytics solutions help you make data-driven decisions and stay ahead of the competition.',
    image: 'https://images.unsplash.com/photo-1509228627152-72ae9ae6848d?auto=format&fit=crop&q=80',
    link: '/solutions/artificial-intelligence'
  },
  {
    title: 'Data Engineering',
    description: 'See how we transformed a UK retail pharmacy\'s operations through comprehensive data engineering and Power BI solutions. Our case study showcases a 60% reduction in manual effort and real-time operational visibility across multiple branches.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80',
    link: '/solutions/data-engineering'
  },
  {
    title: 'Web & Mobile Development',
    description: 'Custom web and mobile applications built with modern frameworks. From responsive websites to native mobile apps, we deliver seamless user experiences across all platforms.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&q=80',
    link: '/solutions/web-mobile-development'
  }
];

const Services = () => {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our Solutions
          </h2>
          <div className="mb-8">
            <h3 className="text-2xl font-semibold text-teal-400 mb-4">Core Service Areas</h3>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Explore our primary solution categories, each designed to address specific enterprise challenges and drive measurable business outcomes.
            </p>
          </div>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Comprehensive solutions tailored to transform your business through automation, 
            AI-powered forecasting, and data-driven insights.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="group relative h-[400px] overflow-hidden rounded-2xl shadow-xl 
                transition-all duration-500 hover:shadow-2xl border border-gray-800/50
                hover:border-teal-400/30 card-hover fade-in-up"
            >
              <div className="absolute inset-0">
                <img
                  src={service.image}
                  alt={`${service.title} Solutions - Agility.AI Technologies`}
                  className="h-full w-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent" />
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-teal-400/30 rounded-2xl transition-all duration-300" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
                <p className="text-gray-300 mb-6 line-clamp-3">{service.description}</p>
                <span className="inline-flex items-center text-teal-400 font-medium 
                  group-hover:text-teal-300 transition-colors">
                  Learn More
                  <svg className="ml-2 w-5 h-5 transition-transform duration-300 
                    group-hover:translate-x-2" fill="none" viewBox="0 0 24 24" 
                    stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                      d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;